const validUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export default class UUID {
  static isValid(uuid) {
    return validUUID.test(uuid);
  }

  /**
   * This method generates a UUID and assigns it as the id for the model.  The UUID is an RFC4122
   * version 4 compliant UUID (https://tools.ietf.org/html/rfc4122 [section 4.4. Algorithms for Creating
   * a UUID from Truly Random or Pseudo-Random Numbers])
   * */
  static generate() {
    // generate 16-bit random numbers
    let buffer = new Uint16Array(8);
    crypto.getRandomValues(buffer);

    return (
      `${UUID._U16ToHex(buffer[0]) + UUID._U16ToHex(buffer[1])}-${UUID._U16ToHex(buffer[2])}-` +
      // set the version number
      `4${UUID._U16ToHex(buffer[3]).substr(-3)}-${
        // set the clock_seq_hi_and_reserved bits 6 & 7 to zero and one respectively
        UUID._U16ToHex((buffer[4] & 0x3fff) | 0x8000)
      }-${UUID._U16ToHex(buffer[5])}${UUID._U16ToHex(buffer[6])}${UUID._U16ToHex(buffer[7])}`
    );
  }

  /**
   * Converts a U16 number into a hexadecimal string
   *
   * @param number {Number}   The number to convert
   * @returns {string}        A hexadecimal representation of the string
   * @private
   */
  static _U16ToHex(number) {
    return `0000${number.toString(16)}`.substr(-4);
  }
}
